/* eslint-disable no-unused-vars */
/* eslint-disable radix */
import React, { useState, useEffect } from 'react'
import { Button, Form, Grid, Modal, Dropdown } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import Swal from 'sweetalert2'
import { useSelector, useDispatch } from 'react-redux'
import styles from './device-modal.module.css'
import IntelMsg from '../../../ItelMsg/index'
import { setCustomerData } from '../../../../redux/actions/deviceData'
import { saveColdDevice, GetUserCustomers } from '../../../../services/asset'
import { GetAllCustomers } from '../../../../services/customer'
import { StandardPlus, Standard, Fixed, Moving, SKU } from './deviceTypesList'

const MACregex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/g
const SIMregex = /^([+]|00)[0-9]{3,}$/g
const GEOLOCATIONregex = /^(-?\d+(\.\d+)?),\s*(-?\d+(\.\d+)?)$/g

const formValidator = {
  customer: yup.string(),
  label: yup.string().required('Please type Device Label'),
  deviceModel: yup.string().required('Please type Device Model'),
  deviceType: yup.string().required('Please Select Device Type'),
  deviceSKU: yup.string().required('Please Select Device SKU'),
  imei: yup.string(),
  macAddress: yup
    .string()
    .required('Please type MAC Address')
    .matches(MACregex, 'Please Match The Format e.g:[14:9c:4b:3a:30:08]'),
  simNo: yup.lazy((value) => {
    if (value.length > 0) {
      return yup
        .string()
        .matches(SIMregex, 'Please Match The Format [Start With 00 or +]')
    }
    return yup.string()
  }),
  description: yup.string(),
  registrationDate: yup.string().required('Please type Registration Date'),
  batteryInstallationDate: yup
    .string()
    .typeError('Please type Battery Installation')
    // eslint-disable-next-line consistent-return
    .when('registrationDate', (registrationDate) => {
      if (registrationDate)
        return yup
          .date()
          .min(
            registrationDate,
            'Battery Installation Date must be after Registration Date',
          )
    }),
  geoLocation: yup
    .string()
    .matches(
      GEOLOCATIONregex,
      'Please Match The Format e.g: [32.23421,31.34557]',
    ),
  warrantyDate: yup.string(),
}
const AddDevice = ({ show, setShow }) => {
  const { userEmail } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
  }))

  const [customersList, setCustomersList] = useState([])
  // eslint-disable-next-line no-unused-vars
  const [customer, setCustomer] = useState()
  const [isMinError, setIsMinError] = useState(false)
  const [isMaxError, setIsMaxError] = useState(false)
  const [isCustomerError, setIsCustomerError] = useState(true)
  const [customerError, setCustomerError] = useState('')
  const [minError, setMinError] = useState('')
  const [maxError, setMaxError] = useState('')
  const [disableSubmit] = useState(false)
  const [deviceType, setDeviceType] = useState('Standard+ Gateway')
  // eslint-disable-next-line no-unused-vars
  const [gateway, setGateway] = useState(true)

  const customerData = []
  const dispatch = useDispatch()

  const deviceTypesList = [
    { key: 1, text: 'Standard+ Gateway', value: 'Standard+ Gateway' },
    { key: 2, text: 'Standard Gateway', value: 'Standard Gateway' },
    { key: 3, text: 'Fixed Gateway', value: 'Fixed Gateway' },
    { key: 4, text: 'Moving Gateway', value: 'Moving Gateway' },
    { key: 5, text: 'Sensor Node', value: 'Sensor Node' },
  ]

  const handleClose = () => setShow(false)

  const { errors, register, handleSubmit, setValue, getValues } = useForm({
    resolver: yupResolver(yup.object().shape(formValidator)),
  })

  useEffect(() => {
    if (userEmail) {
      GetAllCustomers(userEmail, localStorage.getItem('product')).then(
        (data) => {
          console.log('Customer List', data)
          setCustomersList(data || [])
        },
      )
    }
  }, [userEmail])

  useEffect(() => {
    GetUserCustomers(userEmail, 'cold').then((customers) => {
      customers.forEach((c) => {
        console.log('cust', c)
        customerData.push({
          text: c.title,
          value: c.tbCustomerId,
        })
      })
      setCustomersList(customerData)
    })
  }, [])

  const renderIMEI = () => {
    if (gateway)
      return (
        <Grid.Column>
          <span style={{ color: 'black' }}>IMEI:</span>
          <input
            style={{
              backgroundColor: errors.imei ? '#ffe2e7' : null,
            }}
            name="imei"
            ref={register}
            placeholder="..."
            onChange={(e) => {
              if (e.target.value !== '' && e.target.value.length < 15) {
                console.log('min')
                setIsMinError(true)
                setIsMaxError(false)
                setMinError('Please Type 15 Digits')
              } else if (e.target.value !== '' && e.target.value.length > 15) {
                setIsMinError(false)
                setIsMaxError(true)
                setMaxError('IMEI Cannot Exceed 15 Digits')
                console.log('max')
              } else {
                console.log('good')
                setIsMinError(false)
                setIsMaxError(false)
              }
            }}
          />
          <br />
          <p style={{ color: 'red' }}> {isMinError ? minError : null} </p>
          <p style={{ color: 'red' }}> {isMaxError ? maxError : null} </p>
        </Grid.Column>
      )
    return ''
  }

  const renderDeviceSkus = () => {
    if (deviceType === 'Standard Gateway') {
      return Standard.map((item) => (
        <option key={item.key} value={`${item.text}`}>
          {item.text}
        </option>
      ))
    }
    if (deviceType === 'Standard+ Gateway') {
      return StandardPlus.map((item) => (
        <option key={item.key} value={`${item.text}`}>
          {item.text}
        </option>
      ))
    }
    if (deviceType === 'Fixed Gateway') {
      return Fixed.map((item) => (
        <option key={item.key} value={`${item.text}`}>
          {item.text}
        </option>
      ))
    }
    if (deviceType === 'Moving Gateway') {
      return Moving.map((item) => (
        <option key={item.key} value={`${item.text}`}>
          {item.text}
        </option>
      ))
    }
    return SKU.map((item) => (
      <option key={item.key} value={`${item.text}`}>
        {item.text}
      </option>
    ))
  }

  function onSubmit(e) {
    e.deviceName = e.macAddress
    console.log('dataaa: ', e)
    if (isCustomerError) {
      setCustomerError('Please Select Customer')
    } else {
      setCustomerError('')
      // eslint-disable-next-line prefer-destructuring
      // e.customer = e.customer.split(',')[0]
      e.customer = customer
      const newBatteryDate = new Date(e.batteryInstallationDate)
      e.batteryInstallationDate = newBatteryDate.toLocaleDateString()
      const latitude = e.geoLocation.split(',')[0]
      const longitude = e.geoLocation.split(',')[1]
      e.latitude = latitude
      e.longitude = longitude
      saveColdDevice(userEmail, localStorage.getItem('product'), e).then(
        (res) => {
          if (res.success) {
            handleClose()
            Swal.fire({
              title: 'Device Added Successfully!',
              confirmButtonColor: 'Green',
              icon: 'success',
            })
          } else {
            // handleClose()
            Swal.fire({
              title: res.msg || 'Error Adding Device!',
              confirmButtonColor: 'Red',
              icon: 'error',
            })
          }
        },
      )
    }
  }

  const handleChange = (e, data) => {
    setIsCustomerError(false)
    console.log('customerIdddd', data.value)
    dispatch(setCustomerData(data.value))
    setCustomer(data.value)
    setValue('customer', data.value)
  }

  return (
    <>
      <div>
        <Modal
          onClose={() => setShow(false)}
          onOpen={() => setShow(true)}
          open={show}
          centered
          style={{ position: 'relative', height: 'auto' }}
        >
          <Modal.Header className={styles.header} closeButton>
            <IntelMsg id="addDeviceHeaderModal" />
          </Modal.Header>
          <Modal.Content scrolling>
            <Form
              id="deviceAddForm"
              onSubmit={handleSubmit(onSubmit)}
              widths="equal"
            >
              <Form.Field>
                <Grid columns={2}>
                  <Grid.Row>
                    <Grid.Column>
                      <span style={{ color: 'black' }}>Customer:</span>
                      {/* <select
                        name="customer"
                        ref={register}
                        style={{
                          width: 410,
                          height: 40,
                          backgroundColor: errors.customer ? '#ffe2e7' : null,
                        }}
                        onChange={handleCustomerSelect}
                      >
                        {customersList.map((item) => (
                          <option
                            key={item.title}
                            value={`${item.tbCustomerId},${item.title}`}
                          >
                            {item.title}
                          </option>
                        ))}
                      </select>
                      <small style={{ color: 'red' }}>**</small>
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.customer && errors.customer.message}{' '}
                      </p> */}
                      <Dropdown
                        name="customer"
                        ref={register}
                        onChange={(e, data) => {
                          handleChange(e, data)
                        }}
                        options={customersList}
                        selection
                        // placeholder="Please Select Customer"
                        search
                        style={{
                          width: 410,
                          height: 40,
                          // backgroundColor: errors.customer ? '#ffe2e7' : null,
                        }}
                      />
                      <small style={{ color: 'red' }}>**</small>
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {isCustomerError && customerError}{' '}
                      </p>
                    </Grid.Column>
                    <Grid.Column>
                      <span style={{ color: 'black' }}>Device Label:</span>
                      <input
                        className={styles.errorField}
                        name="label"
                        ref={register}
                        placeholder="..."
                      />

                      <small style={{ color: 'red' }}>**</small>
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.label ? errors.label.message : null}{' '}
                      </p>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <span style={{ color: 'black' }}>Device Type:</span>
                      <select
                        name="deviceType"
                        ref={register}
                        style={{
                          width: 410,
                          height: 40,
                          backgroundColor: errors.deviceType ? '#ffe2e7' : null,
                        }}
                        onChange={(e) => {
                          console.log(e.target.value)
                          setDeviceType(e.target.value)
                          if (e.target.value.includes('Gateway'))
                            setGateway(true)
                          else setGateway(false)
                        }}
                      >
                        {deviceTypesList.map((item) => (
                          <option key={item.key} value={`${item.text}`}>
                            {item.text}
                          </option>
                        ))}
                      </select>
                      <small style={{ color: 'red' }}>**</small>
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.deviceType && errors.deviceType.message}{' '}
                      </p>
                    </Grid.Column>
                    <Grid.Column>
                      <span style={{ color: 'black' }}>Device SKU:</span>
                      <select
                        name="deviceSKU"
                        ref={register}
                        style={{
                          width: 410,
                          height: 40,
                          backgroundColor: errors.deviceSKU ? '#ffe2e7' : null,
                        }}
                      >
                        {renderDeviceSkus()}
                      </select>
                      <small style={{ color: 'red' }}>**</small>
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.deviceSKU && errors.deviceSKU.message}{' '}
                      </p>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <span style={{ color: 'black' }}>SIM Number:</span>
                      <input
                        style={{
                          backgroundColor: errors.simNo ? '#ffe2e7' : null,
                        }}
                        name="simNo"
                        ref={register}
                        placeholder="..."
                      />
                      <br />
                      <small style={{ color: 'red' }}>**</small>
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.simNo ? errors.simNo.message : null}{' '}
                      </p>
                    </Grid.Column>
                    {renderIMEI()}
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <span style={{ color: 'black' }}>MAC Address:</span>
                      <input
                        style={{
                          backgroundColor: errors.macAddress ? '#ffe2e7' : null,
                        }}
                        name="macAddress"
                        ref={register}
                        placeholder="..."
                      />
                      <small style={{ color: 'red' }}>**</small>
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.macAddress
                          ? errors.macAddress.message
                          : null}{' '}
                      </p>
                    </Grid.Column>

                    <Grid.Column>
                      <span style={{ color: 'black' }}>Device Model:</span>
                      <input
                        style={{
                          backgroundColor: errors.deviceModel
                            ? '#ffe2e7'
                            : null,
                        }}
                        name="deviceModel"
                        ref={register}
                        placeholder="..."
                      />
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.deviceModel
                          ? errors.deviceModel.message
                          : null}{' '}
                      </p>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <span style={{ color: 'black' }}>Registration Date:</span>
                      <input
                        type="date"
                        style={{
                          backgroundColor: errors.registrationDate
                            ? '#ffe2e7'
                            : null,
                        }}
                        name="registrationDate"
                        ref={register}
                        placeholder="..."
                        onChange={(e) => {
                          console.log(e.target.value)
                          const date = e.target.value.split('-')
                          const year = parseInt(date[0]) + 1
                          const mon = parseInt(date[1])
                          const day = parseInt(date[2])

                          const fullDate = `${
                            mon.toString().length < 2 ? `0${mon}` : mon
                          }/${
                            day.toString().length < 2 ? `0${day}` : day
                          }/${year}`

                          console.log('New Date: ', fullDate)
                          setValue('warrantyDate', fullDate)
                          setValue(
                            'batteryInstallationDate',
                            getValues('registrationDate'),
                          )
                        }}
                      />
                      <small style={{ color: 'red' }}>**</small>
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.registrationDate
                          ? errors.registrationDate.message
                          : null}{' '}
                      </p>
                    </Grid.Column>
                    <Grid.Column>
                      <span style={{ color: 'black' }}>
                        Warranty Expiration Date [mm-dd-yyyy]:
                      </span>
                      <input
                        className={
                          errors.warrantyDate ? styles.errorField : null
                        }
                        type="date"
                        name="warrantyDate"
                        ref={register}
                        placeholder="..."
                      />
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.warrantyDate
                          ? errors.warrantyDate.message
                          : null}{' '}
                      </p>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <span style={{ color: 'black' }}>
                        Battery Installation Date:
                      </span>
                      <input
                        type="date"
                        style={{
                          backgroundColor: errors.batteryInstallationDate
                            ? '#ffe2e7'
                            : null,
                        }}
                        min={getValues('registrationDate')}
                        name="batteryInstallationDate"
                        ref={register}
                        placeholder="..."
                      />
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.batteryInstallationDate
                          ? errors.batteryInstallationDate.message
                          : null}{' '}
                      </p>
                    </Grid.Column>
                    <Grid.Column>
                      <span style={{ color: 'black' }}>Geo Location:</span>
                      <input
                        style={{
                          backgroundColor: errors.geoLocation
                            ? '#ffe2e7'
                            : null,
                        }}
                        name="geoLocation"
                        ref={register}
                        placeholder="..."
                      />
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.geoLocation
                          ? errors.geoLocation.message
                          : null}{' '}
                      </p>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <span style={{ color: 'black' }}>Description:</span>
                      <input
                        className={
                          errors.description ? styles.errorField : null
                        }
                        name="description"
                        ref={register}
                        placeholder="..."
                      />
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.description
                          ? errors.description.message
                          : null}{' '}
                      </p>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Form.Field>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button
              type="submit"
              disabled={disableSubmit}
              form="deviceAddForm"
              className={styles.positiveStatus}
            >
              <IntelMsg id="loginSubmitButton" />
            </Button>
            <Button
              className={styles.negativeStatus}
              onClick={() => {
                handleClose()
              }}
            >
              <IntelMsg id="closeBtn" />
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    </>
  )
}

AddDevice.propTypes = {
  setShow: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
}
export default AddDevice
